import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryCards from "@/pages/home/components/CategoryCards";
import FeaturedFilms from "@/pages/home/components/FeaturedFilms";
import ScreeningPreview from "@/pages/home/components/ScreeningPreview";
import RecentlyViewed from "@/pages/home/components/RecentlyViewed";
import BrandIntro from "@/pages/home/components/BrandIntro";

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />
      <CategoryCards />
      <FeaturedFilms />
      <ScreeningPreview />
      <RecentlyViewed />
      <BrandIntro />
    </div>
  );
}